import React from "react";
import PropTypes from "prop-types";

import ProductsServices from "./ProductsServices";
import { Container } from "./styled";

const ProductServiceSection = ({ productsServicesData, renderAllProductsLink }) => {
  return (
    <Container>
      <ProductsServices
        title={productsServicesData?.title}
        data={productsServicesData?.data}
        size={productsServicesData?.size}
        renderAllProductsLink={renderAllProductsLink}
      />
    </Container>
  );
};

ProductServiceSection.propTypes = {
  productsServicesData: PropTypes.object,
};

export default ProductServiceSection;
